import { ToggleGroup, useTheme } from '@blimo/ui';

const OPTIONS = [
  { value: 'light', label: 'Hell' },
  { value: 'dark', label: 'Dunkel' },
  { value: 'system', label: 'System' },
];

/** Farbschema as segmented control (Hell / Dunkel / System) – same store as `ThemeToggle`. @param {{ className?: string }} props */
export function ThemeSegmented({ className }) {
  const { theme, setTheme } = useTheme();
  return <ToggleGroup label="Farbschema" size="sm" value={theme} onValueChange={setTheme} options={OPTIONS} className={className} />;
}
